export type CaretView = {
  posAtCoords: (coords: { left: number; top: number }) => { pos: number } | null;
  posAtDOM?: (node: Node, offset: number) => number;
  dom?: { ownerDocument?: Document };
};

export function caretPosFromDomPoint(view: CaretView, x: number, y: number): number | null {
  if (!view.posAtDOM) return null;
  const doc = view.dom?.ownerDocument ?? (typeof document === 'undefined' ? null : document);
  if (!doc) return null;

  const range = typeof doc.caretRangeFromPoint === 'function'
    ? doc.caretRangeFromPoint(x, y)
    : null;
  if (range) {
    try {
      return view.posAtDOM(range.startContainer, range.startOffset);
    } catch {
      return null;
    }
  }

  const caretPositionFromPoint = (doc as Document & {
    caretPositionFromPoint?: (left: number, top: number) => { offsetNode: Node; offset: number } | null;
  }).caretPositionFromPoint;
  const position = typeof caretPositionFromPoint === 'function' ? caretPositionFromPoint(x, y) : null;
  if (!position) return null;
  try {
    return view.posAtDOM(position.offsetNode, position.offset);
  } catch {
    return null;
  }
}

export function caretPosFromPoint(view: CaretView, x: number, y: number): number | null {
  const found = view.posAtCoords({ left: x, top: y });
  if (found) return found.pos;
  return caretPosFromDomPoint(view, x, y);
}
